import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { formatDate, formatNumber } from 'wc-lib';

@Component({
  template: require('./fpp-unit-dcf-table.html'),
  name: 'fpp-unit-dcf-table'
})
export class FppUnitDcfTable extends Vue {
  @Prop() data: any[];
  @Prop() pageSize: number;

  columns = [
    { title: 'FPP Unit ID', sortColumn: 'FUID' }, 
    { title: 'Constraint ID', sortColumn: 'CID' },
    { title: 'Effective\nStart Date', sortColumn: 'ESD' },
    { title: 'Effective\nEnd Date', sortColumn: 'EED' },
    { title: 'Version #', sortColumn: 'VN' },
    { title: 'Bid Type', sortColumn: 'BT' },
    { title: 'Region ID', sortColumn: 'RID' },
    { title: 'DCF', sortColumn: 'DCF' },
    { title: 'DCF Reason\nFlag', sortColumn: 'DRF' },
    { title: 'DCF Absolute Negative\nPerformance Total (MWHz)', sortColumn: 'DANPT' },
  ];

  maxPages: number = 0;

  sortColumn: string = this.columns[0].sortColumn;
  sortAscending: boolean = true;

  pageNum: number = 1;
  pageNums: number[] = [];
  pageRows: any[] = [];

  created() {
    this.maxPages = Math.ceil(this.data.length / this.pageSize);
    this.setPageNums();
    this.setPageRows();
  }

  changePage(newPageNum: number): void {
    this.pageNum = newPageNum;
    this.setPageNums();
    this.setPageRows();
  }

  sort(column: string, ascending: boolean): void {
    this.sortColumn = column;
    this.sortAscending = ascending;

    this.changePage(1);
  }

  sortActive(column: string, ascending: boolean) {
    return column === this.sortColumn && ascending === this.sortAscending ? 'active' : '';
  }

  setPageNums(): void {
    this.pageNums = [];

    for (let i = 1; i <= this.maxPages; i++) {
      if (i === 1
        || i === this.maxPages
        || (i >= this.pageNum - 2 && i <= this.pageNum + 2)) {
        this.pageNums.push(i);
      }
      else {
        if (this.pageNums.length > 0 && this.pageNums[this.pageNums.length - 1] !== -1) {
          this.pageNums.push(-1); // rendered as '...'
        }
      }
    }
  }

  setPageRows(): void {
    let sortedData: any[] = [...this.data];
    if (this.sortAscending) {
      sortedData.sort((a, b) => b[this.sortColumn] > a[this.sortColumn] ? -1 : 1);
    }
    else {
      sortedData.sort((a, b) => a[this.sortColumn] > b[this.sortColumn] ? -1 : 1);
    }

    this.pageRows = [];
    for (let i = (this.pageNum - 1) * this.pageSize; i < Math.min(this.pageNum * this.pageSize, sortedData.length); i++) {
      let row = sortedData[i];
      this.pageRows.push({ 
        ...row,
        ESD: formatDate(row.ESD, 'dd/MM/yyyy HH:mm'),
        EED: formatDate(row.EED, 'dd/MM/yyyy HH:mm'),
        DCF: row.DCF.toFixed(5),
        DANPT: row.DANPT.toFixed(5),
      });
    }
  }
}



// WEBPACK FOOTER //
// src/views/electricity/fpp/fpp-unit-dcf-table.ts